import { FundingStatuses } from "../../../classes/Api/Funding";
import { VehicleLifeCycleStatuses } from "../../../classes/Api/Vehicle";
import Moment from "moment";
const financeHouses = () => {
    return window.marque.ui.fundingFinanceHouses;
};
const hasFunding = (instance) => {
    return !!instance.funding_record;
};
const expiringSoon = (instance) => {
    return Moment(instance.funding_record.funding_expires_at).diff(Moment(), 'days') < 3 &&
        instance.funding_record.funding_status === FundingStatuses.LIVE;
};
const warningCss = (instance) => {
    return [
        'color: ' + ((expiringSoon(instance) || isSold(instance)) ? 'orange' : 'inherit'),
        'font-weight:' + ((expiringSoon(instance) || isSold(instance)) ? 'bold' : 'inherit'),
        'text-align: center;',
    ].join(';');
};
const isSold = (instance) => {
    return instance.life_cycle_status >= VehicleLifeCycleStatuses.AWAITING_DELIVERY;
};
const isFundingSettled = (instance) => {
    return instance.funding_record.funding_status === FundingStatuses.SETTLED;
};
const daysRemaining = (instance) => {
    return Moment(instance.funding_record.funding_expires_at).diff(Moment(), 'days');
};
const financeHouseLabel = (instance) => {
    let houseId = hasFunding(instance) ?
        instance.funding_record.finance_house : null;
    // @ts-ignore
    let entry = financeHouses().find(i => {
        return i.id === houseId;
    });
    if (entry) {
        return entry.label;
    }
    return houseId;
};
export { hasFunding, financeHouseLabel, expiringSoon, financeHouses, isSold, isFundingSettled, daysRemaining, warningCss, };
